import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { Observable, take, tap } from 'rxjs';
import { Store, select } from '@ngrx/store';
import {
  selectAuthUserAlertsLoaded,
  selectAuthUserAlertsLoading,
  selectAuthUserTriggeredAlerts,
} from 'src/app/core/reducers';

import { Alert } from 'src/app/core/models/alert.models';
import { AppState } from 'src/app/reducers';
import { loadTriggeredAlerts } from 'src/app/core/actions/auth.actions';
import { toggleExpandAlert } from '../../../actions/auth.actions';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AlertService } from 'src/app/core/services/alert.service';

@Component({
    selector: 'app-dropdown-alerts',
    templateUrl: './dropdown-alerts.component.html',
    styleUrls: ['./dropdown-alerts.component.scss'],
    standalone: false
})
export class DropdownAlertsComponent implements OnInit {
  @Input() closeMethod!: () => void;

  alerts$: Observable<Alert[]>;
  alertsLoading$: Observable<boolean>;

  private destroyRef = inject(DestroyRef);

  alertExpanded: boolean = false;
  alertCount: number;

  constructor(
    private store: Store<AppState>,
    public alertService: AlertService,
  ) {
    this.store
      .pipe(
        select(selectAuthUserAlertsLoaded),
        take(1),
        tap((loaded) => {
          if (!loaded) {
            this.store.dispatch(loadTriggeredAlerts());
          }
        }),
      )
      .subscribe();

    this.alerts$ = this.store.select(selectAuthUserTriggeredAlerts);
    this.alertsLoading$ = this.store.select(selectAuthUserAlertsLoading);
    this.alerts$
      .pipe(
        tap((alerts) => {
          this.alertCount = alerts.length;
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  ngOnInit() {}

  toggleExpandAlert(id) {
    event.stopPropagation();
    this.store.dispatch(toggleExpandAlert({ id }));
  }
}
